import React from 'react';
import { FactoryIcon, ShieldCheckIcon, TagIcon, UsersIcon } from 'lucide-react';
const items = [{
  label: 'Family-Owned Since 2000',
  Icon: UsersIcon
}, {
  label: 'Free Estimates & Expert Advice',
  Icon: TagIcon
}, {
  label: 'In-House Glass Fabrication',
  Icon: FactoryIcon
}, {
  label: 'We Work With All Major Insurers',
  Icon: ShieldCheckIcon
}];
export function TrustStrip() {
  return <section aria-label="Why customers choose Kosin’s Glass" className="border-b border-kosin-line bg-kosin-mist" data-id="element-329" data-mp="2acxkvn4bzwnz">
      <ul className="mx-auto flex max-w-shell flex-wrap justify-center gap-x-6 gap-y-4 px-[18px] py-5 text-[13px] text-kosin-ink sm:px-6 sm:text-[15px] lg:flex-nowrap lg:justify-between lg:gap-x-3 lg:py-4 lg:text-[14px] xl:text-[15px]" data-id="element-330" data-mp="25cjiolpevgxv">
        {items.map(({
        label,
        Icon
      }) => <li key={label} className="flex w-[calc(50%-12px)] items-center justify-center gap-2.5 text-center sm:w-auto sm:text-left lg:whitespace-nowrap" data-id="element-331" data-mp="3ur7xetlh5az2">
            <Icon className="h-[18px] w-[18px] shrink-0 text-kosin-red" aria-hidden="true" data-id="element-332" data-mp="3msbg1q4l3dw4" />
            <span data-id="element-333" data-mp="3rt8wny9y3zvi">{label}</span>
          </li>)}
      </ul>
    </section>;
}